import { useCallback, useState } from 'react';
import useMounted from './useMounted';

export default (
  initial?: boolean,
): [boolean, () => void, (val: boolean) => void, () => void, () => void] => {
  const isMounted = useMounted();
  const [value, setValue] = useState(!!initial);

  const toggle = useCallback(() => {
    if (isMounted()) {
      setValue((prev) => !prev);
    }
  }, []);

  const unset = useCallback(() => {
    setValue(false);
  }, []);

  const set = useCallback(() => {
    setValue(true);
  }, []);

  return [value, toggle, setValue, unset, set];
};
